export const privacyPolicySectionContentMotion = {
    initial: { opacity: 0 },
    whileInView: 'animated',
    viewport: { once: true, amount: 0.2 },
    variants: {
        animated: {
            opacity: [0, 1],
            transition: {
                duration: 0.4,
                ease: 'easeIn',
            },
        },
    },
};
